import styled, { css } from 'styled-components'
import { Row, Col } from '@microfrontends/react-components'
import { CompanyItemWrapper } from '../CompanyItem/CompanyItem.css'
import { CSSProperties } from 'react'

export const CompanyBlockHeader = styled(Row)``

export const CompanyContent = styled(Row)`
    display: flex;
    margin: -8px;
    padding: 16px 0;
    @media screen and (min-width: 768px) {
        padding-bottom: 0;
    }
    > div {
        display: inline-flex;
        width: 32%;
        margin: 8px;
        @media screen and (max-width: 425px) {
            width: calc(100% - 16px);
        }
        @media screen and (min-width: 426px) and (max-width: 1024px) {
            width: calc(50% - 16px);
        }
        @media screen and (min-width: 1025px) and (max-width: 1680px) {
            width: calc(33% - 16px);
        }
    }
    ${CompanyItemWrapper} {
        flex-direction: column;
    }
`

export const TabMenu = styled(Col)`
    display: flex;
    overflow-x: auto;
    /* Hide scrollbar for Chrome, Safari and Opera */
    ::-webkit-scrollbar {
        display: none;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
`

export const TabItem = styled.div<{ isActive?: boolean }>`
    line-height: 17px;
    font-size: 14px;
    padding: 0 8px 10px 8px;
    cursor: pointer;
    font-weight: ${({ isActive }) => isActive ? '700' : '400'};
    color: ${({ isActive }) => isActive ? '#005aff' : '#666'};
    border-bottom:${({ isActive }) => isActive ? '2px solid #005aff' : '2px solid transparent'};
    white-space: nowrap;
`

export const ViewAllButton = styled(Col)<{ isBottom?: boolean }>`
    text-align: right;
    a {
        color: #005aff;
        text-decoration: none;
    }
    &:hover {
        a {
            color: #ff7d55;
        }
        svg {
            path {
                fill: #ff7d55;
            }
        }
    }
    ${({ isBottom }) => {
        if (!isBottom) {
            return ''
        }
        return css`
            a {
                display: block;
                width: 100%;
                background-color: #f2f7ff;
                border-radius: 6px;
                text-align: center;
                padding: 12px 0;
                margin-top: 8px;
            }
        `
    }}
`

export const EmptyFollowedStyle: CSSProperties = {
    backgroundColor: '#F9F9F9',
    marginTop: 20
}
